<template>
  <div class="hy-people">
    <!--嘉宾详情-->
    <div class="people_info people_info_inpage">
    <!--  <div class="top">
        <div class="textbox" style="padding-top:0px;">
          <h5 class="hy_name">{{newInfo.title}}</h5>
          <p class="hy_ssapid"> 发布时间： {{newInfo.publish_time,'Y-M-D'|formatDates}} </p>
        </div>
      </div>-->
      <div class="infobox" :class="newInfo.is_full == 1?'noPading':'' ">
        <div class="infotext" v-html="newInfo.content"></div>
      </div>
    </div>
    <!--底部按钮-->
    <template v-if="Object.keys(newInfo).length != 0">
      <footerFixed :id="newInfo.conference_id" :jump-page="newInfo.jump_page" />
    </template>

  </div>
</template>


<script>
  import {
    formatDates
  } from '@/assets/js/date.js';
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
    data() {
      return {
        id: '',
        newInfo: {},
        loading: false,
        finished: false,
        footerNav: false,
      };
    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    created() {
      var _this = this;
      _this.id = _this.$route.params.id;
      _this.$toast.loading({
        message: '加载中...',
        forbidClick: true,

      });
      setTimeout(function() {
        _this.$toast.clear();
      }, 500);

      var wxShareInfo = {
        title: _this.newInfo.title,
        info: _this.$options.filters['formatDates'](_this.newInfo.publish_time, 'Y-M-D'),
        shareurl: window.location.href,
        img: ''
      };
      _this.$WXConfig.wxShowMenu({
        ifshare: true,
        that: _this,
        data: wxShareInfo
      });
    },
    methods: {
      //banner跳转方法
      goPath(path) {
        if (path == '') {
          return false;
        }
        this.$router.push(path)
      },
      //搜索方法
      onSearch(val) {
        this.$toast(val);
      },
      addList() {
        var _this = this;
        this.$get('/ac1/conference/column/list', {
          id: _this.id,
          type: 1
        }).then(res => {
          _this.newInfo = res.posts;
          document.title= _this.newInfo.title;
        })
      },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
    },
    mounted() {
      this.addList();
    }
  }
</script>
<style lang="less">
  .people_info_inpage{
    .noPading{
      padding: 0px!important;
      .infotext{
        margin: 0 auto !important;
        img{
          margin: 0 auto!important;
        }
      }
    }
  }
</style>
